export default __webpack_public_path__ + "static/media/FicarraKelly.ed13c71e.jpeg";